import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    technologyList : [],
    selectedtechnology:{},
}
const technologySlice = createSlice({
    name:'technology',
    initialState,
    reducers:{
        setTechnologyList:(state,{payload})=>{
            state.technologyList = payload
        },
        setTechnologyProfile:(state,{payload})=>{
            state.selectedtechnology = payload
        },
    }
})

export const { setTechnologyList,setTechnologyProfile} = technologySlice.actions
export default technologySlice.reducer